import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette: {
    mode: "dark",
    primary: {
      main: "#818cf8",
    },
    secondary: {
      main: "#764ba2",
    },
    background: {
      default: "#0f0f1a",
      paper: "#1a1a2e",
    },
    text: {
      primary: "#ffffff",
      secondary: "rgba(255,255,255,0.55)",
    },
  },
  typography: {
    fontFamily: '"Quicksand", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: "3rem",
      fontWeight: 700,
      color: "#ffffff",
      textAlign: "center",
    },
    h2: {
      fontSize: "2.5rem",
      fontWeight: 700,
      color: "#ffffff",
      textAlign: "center",
    },
    h6: {
      fontWeight: 600,
    },
    body1: {
      fontSize: "1rem",
      lineHeight: 1.6,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          fontSize: "1.1rem",
          padding: "12px 24px",
          borderRadius: "8px",
        },
        contained: {
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "#ffffff",
          "&:hover": {
            background: "linear-gradient(135deg, #5a6fd6 0%, #6a4190 100%)",
          },
        },
        outlined: {
          borderColor: "rgba(255,255,255,0.4)",
          color: "#ffffff",
          "&:hover": {
            borderColor: "#ffffff",
            backgroundColor: "rgba(255,255,255,0.08)",
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          padding: "24px",
          borderRadius: "12px",
          backgroundColor: "#1a1a2e",
          boxShadow: "0 2px 16px rgba(0,0,0,0.4)",
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a2e",
          border: "1px solid rgba(255,255,255,0.06)",
          borderTop: "3px solid #818cf8",
          transition: "transform 0.2s ease, box-shadow 0.2s ease",
          "&:hover": {
            transform: "translateY(-6px)",
            boxShadow: "0 16px 40px rgba(129, 140, 248, 0.2)",
          },
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          backgroundColor: "rgba(15,15,26,0.92)",
          backdropFilter: "blur(12px)",
          boxShadow: "0 1px 0 rgba(255,255,255,0.06)",
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          backgroundColor: "#1a1a2e",
          border: "1px solid rgba(255,255,255,0.06)",
          "&:before": { display: "none" },
          "&.Mui-expanded": {
            borderLeft: "3px solid #818cf8",
            margin: 0,
          },
        },
      },
    },
  },
});

export default theme;
